/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WidgetTypes,
    WidgetTypesFromJSON,
    WidgetTypesFromJSONTyped,
    WidgetTypesToJSON,
} from './';

/**
 * 
 * @export
 * @interface WidgetTypeDto
 */
export interface WidgetTypeDto {
    /**
     * 
     * @type {WidgetTypes}
     * @memberof WidgetTypeDto
     */
    type: WidgetTypes;
    /**
     * 
     * @type {Array<string>}
     * @memberof WidgetTypeDto
     */
    data: Array<string>;
}

export function WidgetTypeDtoFromJSON(json: any): WidgetTypeDto {
    return WidgetTypeDtoFromJSONTyped(json, false);
}

export function WidgetTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetTypeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': WidgetTypesFromJSON(json['type']),
        'data': json['data'],
    };
}

export function WidgetTypeDtoToJSON(value?: WidgetTypeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': WidgetTypesToJSON(value.type),
        'data': value.data,
    };
}


